import React from "react";

const RoundedBorder = ({ children, style = {}, className = "" }) => {
  return (
    <div
      className={className}
      style={{
        border: "1px solid #ccc",
        borderRadius: "8px",
        overflow: "hidden",
        marginBottom: "1rem",
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default RoundedBorder;
